import api from './api';
import { getItem } from './localSorage';
import { ITemporaryAnnouncement, ITemporaryAnnouncementSpot } from '../interfaces/temporaryAnnouncements';

type Props = {
  spot: ITemporaryAnnouncementSpot;
}

export async function getActiveTemporaryAnnouncements({
  spot,
}: Props): Promise<ITemporaryAnnouncement | null> {
  const uri = `dispenser/temporary-announcements`;
  const { data: { data } } = await api.get(uri, {
    params: {
      token: getItem('token'),
      spot,
    },
  });

  if (!data) return null;

  const normalizedData: ITemporaryAnnouncement = data ? {
    ...data,
    cta: data.cta ? {
      ...data.cta,
      type: 'link' as const
    } : null
  } : null;

  return normalizedData;
};

export const TEMPORARY_ANNOUNCEMENTS_LOCAL_STORAGE_PREFIX = 'dispensador-dispensation-announcement';

export function resetAnnouncementsState(): void {
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(TEMPORARY_ANNOUNCEMENTS_LOCAL_STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  }
}
